const followeeUpdateActions = {
  REMOVE: 'remove',
  ADD: 'add',
  FAVOURITE: 'ParticipantFavourite',
  UNFAVOURITE: 'ParticipantUnFavourite'
};

const addFollowee = (followeeList, followeeId) => {
  const followee = { followeeId, followeeType: 'Individual' };
  return [...followeeList, followee];
};

const removeFollowee = (followeeList, followeeId) => followeeList.filter((f) => f.followeeId !== followeeId);

const updateNetworkFollowees = (followeeList, followeeId, action) => {
  if (action === followeeUpdateActions.ADD || action === followeeUpdateActions.FAVOURITE) {
    return addFollowee(followeeList, followeeId);
  }
  if (action === followeeUpdateActions.REMOVE || action === followeeUpdateActions.UNFAVOURITE) {
    return removeFollowee(followeeList, followeeId);
  }
  return followeeList;
};

export {
  followeeUpdateActions,
  updateNetworkFollowees
};
